// extracted by mini-css-extract-plugin
export default {"IconContainer":"SignUpSuccess_IconContainer__kGC4g"};